import MVVMBase from "../../../../../framework/core/mvvm/mvvm_base";
import { ListView, ListViewDir } from "../../../../../framework/tools/scrollview/listview";
import { TaskHelp } from "../task_help";
import Utility from "../../../../../utility/utility";
import ModuleManager from "../../../../../framework/core/module_manager";
import { TaskDataCache } from "../task_data";
import EventManager from "../../../../../manager/event_manager";
import SpriteFrameHolder from "../../../../public/ui/spriteFrameHolder";

const {ccclass, property} = cc._decorator;

@ccclass
export class TaskBase extends cc.Component {

    protected m_list: ListView = null

    @property(cc.ScrollView)
    itemListScrollView: cc.ScrollView = null

    @property(cc.Node)
    itemListView: cc.Node = null

    @property(cc.Node)
    nodeItemListConent: cc.Node = null

    taskName:string;

    isInit:boolean;

    taskModuleName:string;

    mvvmBase:MVVMBase = null;

    init(mvvmBase:MVVMBase,name?:string,taskModuleName?:string){
        this.mvvmBase = mvvmBase;
        this.taskName = name;
        this.taskModuleName = taskModuleName
        this.isInit = false;
        let list: ListView = new ListView({
            scrollview: this.itemListScrollView,
            view: this.itemListView,
            content: this.nodeItemListConent,
            item_prefab: this.getPrefab(),
            cb_host: this,
            item_update_func: this.update_list_item,
            column: 1,
            row: 5,
            gap_x:20,
            gap_y:20,
            direction: ListViewDir.Vertical,
        });
        this.m_list = list
    }

    changePanel(toggle:cc.Toggle,finish?:Function){
        let isMySelf = toggle.node.name == this.taskName
        this.node.active = isMySelf;
        if (isMySelf) {
            this.onActive(finish);
        }
    }

    onActive(finish?:Function){
        finish && finish();
    }

    getPrefab():cc.Node{
        return null;
    }

    setItemData(data:any[]){
        if (this.isInit) {//已经初始化
            //数据删除
            if (data.length == 0) {
                this.m_list.set_data([]);
            }else{
                let itemsCnt = this.m_list.datas.length;
                let deleteCnt = itemsCnt - data.length;
                if (deleteCnt >= 1) {
                    let i = 0;
                    let index = itemsCnt-1;
                    while (deleteCnt>0) {
                        this.m_list.remove_data(index,1);
                        index--;
                        deleteCnt--;
                    }
                }else if(deleteCnt <= -1){//add
                    let cnt = Math.abs(deleteCnt);
                    while (cnt > 0) {
                        this.m_list.append_data(data[0])
                        cnt--;
                    }
                }
    
                for (let i = 0; i < data.length; i++) {
                    this.refreshOneItem(i,data[i]);
                }
            }
           
        }else{
            this.m_list.set_data(data)
        }
        this.isInit = true;
    }

    refreshOneItem(index:number,data:any){
        this.m_list.refresh_item(index,data)
    }

    refreshAllItem(finish?:Function){

    }

    //任务领取刷新
    onAwardTask(finish?:Function){
        //领取完成更新
        let self = this;
        //更新红点
        this.mvvmBase.eventDispatch('Event_Notify_RedPoint')
        TaskDataCache.instance.getTaskData(this.taskModuleName,(data:any[])=>{
            self.setItemData(data);
        },this.mvvmBase,true);
    }

    clickItemFunc(data:any){
        Utility.playButtonSound();
        let self = this;
        if (data.isFinish && !data.isReceive) {//可领取
            TaskHelp.taskAward(data.taskRefId,data.taskTypeCode,(awardData:any)=>{
                self.showAwardAnim(awardData);
                //刷新所有item
                self.onAwardTask();
            },this.mvvmBase)
        }else{
            if (!data.isFinish) {//去完成
                TaskHelp.goToFinishTask(data.conditionCode);
                //EventManager.instance.dispatch('_task_state_',false);
            }
        }

    }

    private showAwardAnim(data:any){
        this.mvvmBase.getSelfCurrencyData(null, true)
        if(data){
            let moneylist = [];
            let numb =  Number(data.awardAccountVal);
            if (data.awardAccountType == 5) {
                moneylist.push({type:5,num:numb})
            }else if(data.awardAccountType == 6){
                moneylist.push({type:6,num:numb})
            }else if (data.awardAccountType == 100) {
                moneylist.push({type:100,num:numb})
            }      
            ModuleManager.instance.showModuleName('DialogReceive',moneylist)
        }
    }

    protected update_list_item(itemNode: cc.Node, data: any, index: number){
    }

    clear(){

    }

    hide(){
        this.isInit = false;
        this.m_list.set_data([])
    }

}
